export default {
	offer: 'Ofertas',
	purchases: 'Compras',
	total: 'Total'
}